import React from 'react';
import CFaqArticle from '../components/CFaqArticle';
import IFaqArticle from '../interfaces/IFaqArticle';

type VFaqArticleListProps = {
	articles: IFaqArticle[];
};
const VFaqArticleList = (props: VFaqArticleListProps) => {
	const { articles } = props;
	return (
		<>
			{articles &&
				articles.map((article, index) => {
					return <CFaqArticle article={article} key={index} />;
				})}
		</>
	);
};

export default VFaqArticleList;
